import { useState } from "react";
import iconArrow from "../../static/icon-arrow.svg";
import "./Banner.scss";

function Banner() {
    const [arrow, setArrow] = useState(false);

    window.addEventListener("scroll", () => {
        if (window.pageYOffset > 60) {
            setArrow(true)
        } else {
            setArrow(false)
        }
    })

    return (
        <section className="banner">
            <div className="container">
                <div className="banner__wrapper">
                    <div className="banner__wrapper__text">
                        <h1 className="banner__wrapper__text__h1">
                        TIRE SUA EMPRESA DA CAIXA<br/>
                        CONVERTA VISITAS EM CLIENTES</h1>
                        <a className="cta" target="_blank" href="https://wa.me/5511946414012" rel="noopener noreferrer">Saia da caixa</a>
                    </div>

                    <div className="banner__wrapper__cube">
                        <div className="banner__wrapper__cube__face face1"></div>
                        <div className="banner__wrapper__cube__face face2"></div>
                        <div className="banner__wrapper__cube__face face3"></div>
                        <div className="banner__wrapper__cube__face face4"></div>
                        <div className="banner__wrapper__cube__face face5"></div>
                        <div className="banner__wrapper__cube__face face6"></div>
                    </div>

                    <div className="banner__wrapper__grid">
                        <div className="banner__wrapper__grid__line line1"></div>
                        <div className="banner__wrapper__grid__line line2"></div>
                        <div className="banner__wrapper__grid__line line3"></div>
                        <div className="banner__wrapper__grid__line line4"></div>
                        <div className="banner__wrapper__grid__line line5"></div>
                        <div className="banner__wrapper__grid__line line6"></div>
                        <div className="banner__wrapper__grid__line line7"></div>
                        <div className="banner__wrapper__grid__line line8"></div>
                        <div className="banner__wrapper__grid__line line9"></div>
                        <div className="banner__wrapper__grid__line line10"></div>
                        <div className="banner__wrapper__grid__line line11"></div>
                        <div className="banner__wrapper__grid__line row row1"></div>
                        <div className="banner__wrapper__grid__line row row2"></div>
                        <div className="banner__wrapper__grid__line row row3"></div>
                        <div className="banner__wrapper__grid__line row row4"></div>
                        <div className="banner__wrapper__grid__line row row5"></div>
                        <div className="banner__wrapper__grid__line row row6"></div>
                        <div className="banner__wrapper__grid__line row row7"></div>
                        <div className="banner__wrapper__grid__line row row8"></div>
                        <div className="banner__wrapper__grid__line row row9"></div>
                        <div className="banner__wrapper__grid__line row row10"></div>
                        <div className="banner__wrapper__grid__line row row11"></div>
                    </div>

                    <div className={arrow ? "banner__wrapper__arrow hidden" : "banner__wrapper__arrow"}>
                        <a href="#servicos">
                            <img src={iconArrow} alt="Ícone de seta"/>
                        </a>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Banner;